import { useMemo } from "react";

import useRecycleMaterials from "./useRecycleMaterials";
import useProducts from "./useProducts";
import useNonEligibleMaterials from "./useNonEligibleMaterials";

import { BusinessRole, MaterialConfig } from "../types/domain";

const useMaterialsByCode = (businessRoles?: BusinessRole[]) => {
  const { data: materials } = useRecycleMaterials(businessRoles);
  const { data: products } = useProducts();
  const { data: nonEligibleMaterials } = useNonEligibleMaterials();

  const materialsByCode = useMemo(
    () =>
      [
        ...(materials || []),
        ...(products || []),
        ...(nonEligibleMaterials || []),
      ].reduce((result, material) => {
        result[material.code] = material;
        return result;
      }, {} as { [key: string]: MaterialConfig }),
    [materials, products, nonEligibleMaterials]
  );

  return materialsByCode;
};

export default useMaterialsByCode;
